 <div class="loader fa fa-spinner fa-spin" *ngIf="loaderService.isLoading | async"></div>
